import React, { FC } from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';

import { OrganizationSettingsTab, getOrganizationSettingUrls } from 'src/urls/getOrganizationSettingUrls';

import AppWideBanner from '../AppWideBanner';

import { generateServiceUserMessageI18n, getBannerConfig, getExpirationInfo } from './utils';

interface MicrosoftServiceUser {
  updatedAt: string;
}

interface Props {
  microsoftServiceUser: MicrosoftServiceUser | null | undefined;
}

const MicrosoftServiceUserExpirationBanner: FC<Props> = ({ microsoftServiceUser }) => {
  const { t } = useTranslation();
  if (!microsoftServiceUser) {
    return null;
  }

  const expirationInfo = getExpirationInfo(microsoftServiceUser.updatedAt);

  if (expirationInfo.status === 'none') {
    return null;
  }

  const bannerConfig = getBannerConfig(expirationInfo.status);
  if (!bannerConfig) {
    return null;
  }

  const message = generateServiceUserMessageI18n(t, expirationInfo.status, expirationInfo.daysRemaining);

  const integrationsUrl = getOrganizationSettingUrls({ tab: OrganizationSettingsTab.INTEGRATIONS });

  return (
    <AppWideBanner
      text={message}
      backgroundColor={bannerConfig.backgroundColor}
      color={bannerConfig.color}
      action={{
        label: t('hiring-dashboard-nav:nav.banner.goToIntegrations'),
        href: integrationsUrl,
      }}
    />
  );
};

export const MicrosoftServiceUserExpirationBannerFragments = {
  microsoftServiceUser: gql`
    fragment MicrosoftServiceUserExpirationBanner_microsoftServiceUser on MicrosoftServiceUserIntegration {
      updatedAt
    }
  `,
};

export default MicrosoftServiceUserExpirationBanner;
